import { render, staticRenderFns } from "./ChangeRoomsRates.vue?vue&type=template&id=5c779ee6&"
import script from "./ChangeRoomsRates.vue?vue&type=script&lang=js&"
export * from "./ChangeRoomsRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c779ee6')) {
      api.createRecord('5c779ee6', component.options)
    } else {
      api.reload('5c779ee6', component.options)
    }
    module.hot.accept("./ChangeRoomsRates.vue?vue&type=template&id=5c779ee6&", function () {
      api.rerender('5c779ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ChangeRoomsRates.vue"
export default component.exports